import { Link } from 'react-router-dom';
import { useAuthStore } from '@/features/auth';
import { SystemStatusIcon } from '@/shared/config';
import { Tooltip } from '@/shared/ui';
import { cn } from '@/shared/lib/cn';
import { useSystemStatusStore } from '../model/system-status-store';
import { useSystemStatusLive } from '../model/useSystemStatusLive';
import { OVERALL_LABEL, STATUS_LABEL, problemsOf } from '../lib/status-text';
import styles from './StatusIndicator.module.css';

export function StatusIndicator() {
  const isStaff = useAuthStore((s) => s.hasPermission('view_tickets'));
  useSystemStatusLive();
  const summary = useSystemStatusStore((s) => s.summary);
  if (!isStaff) return null;

  const overall = summary?.overall ?? 'unknown';
  const problems = problemsOf(summary);
  const loud = overall === 'down' || overall === 'degraded';

  const tooltip = problems.length ? (
    <div className={styles.tip}>
      <div className={styles.tipTitle}>{OVERALL_LABEL[overall]}</div>
      {problems.map((c) => (
        <div key={c.key} className={styles.tipRow}>
          {c.label} — {STATUS_LABEL[c.status].toLowerCase()}
        </div>
      ))}
    </div>
  ) : (
    `Состояние портала: ${OVERALL_LABEL[overall].toLowerCase()}`
  );

  return (
    <Tooltip content={tooltip} side="bottom">
      <Link
        to="/status"
        className={cn(styles.indicator, overall !== 'unknown' && styles.toned, loud && styles.loud, styles[`tone-${overall}`])}
        aria-label={`Состояние портала: ${OVERALL_LABEL[overall].toLowerCase()}`}
      >
        <span className={styles.glyph} aria-hidden>
          <SystemStatusIcon size={14} strokeWidth={2.25} />
          <span className={styles.dot} />
        </span>
        <span className={styles.label}>Статус</span>
      </Link>
    </Tooltip>
  );
}
